export default "__VITE_ASSET__BUlmMGGE__"